import graphql__9e390eb5e3579cfa7b0a from "./__generated__/UpdatePhoneNumberMutation.graphql.js";import { commitMutation, graphql } from "react-relay";
import mapValues from "lodash/mapValues";

import appRelayEnvironment from "../config/AppRelayEnvironment";

const mutation = graphql__9e390eb5e3579cfa7b0a;

async function updatePhoneNumber(form) {
  const variables = mapValues(form.fields, field => field.value);

  return new Promise((resolve, reject) => {
    commitMutation(appRelayEnvironment, {
      mutation,
      variables,
      onCompleted: (response, errors) => {
        if (errors) {
          reject(errors);
        } else {
          resolve(response);
        }
      },
      onError: error => {
        console.error(error);
        reject(error);
      }
    });
  });
}

export { updatePhoneNumber };
